import React from 'react';
import { Accordion, Card, Row, Col } from 'react-bootstrap';
import { FaHeartbeat, FaFemale, FaSyringe, FaStethoscope, FaBrain, FaAppleAlt } from 'react-icons/fa';

function WomensHealth() {
  return (
    <div className="container my-5">
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold text-gradient-primary mb-3">
          Women's Health Services
        </h1>
        <p className="lead text-muted">
          Comprehensive care for every stage of life
        </p>
      </div>

      <Accordion defaultActiveKey="0" className="mb-5 shadow-lg">
        <Accordion.Item eventKey="0" className="border-0">
          <Accordion.Header className="bg-light hover-bg-primary">
            <div className="d-flex align-items-center">
              <FaFemale className="text-primary fs-4 me-3" />
              <h3 className="mb-0">Reproductive Health</h3>
            </div>
          </Accordion.Header>
          <Accordion.Body className="py-4">
            <Row className="g-4">
              <Col md={4}>
                <div className="d-flex align-items-start p-3 bg-light rounded-3">
                  <FaHeartbeat className="text-primary fs-3 me-3" />
                  <div>
                    <h5>Menstrual Health</h5>
                    <p className="mb-0 text-muted">Cycle tracking & disorder management</p>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="d-flex align-items-start p-3 bg-light rounded-3">
                  <FaSyringe className="text-primary fs-3 me-3" />
                  <div>
                    <h5>Pregnancy Care</h5>
                    <p className="mb-0 text-muted">Antenatal & postnatal services</p>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="d-flex align-items-start p-3 bg-light rounded-3">
                  <FaStethoscope className="text-primary fs-3 me-3" />
                  <div>
                    <h5>Menopause Management</h5>
                    <p className="mb-0 text-muted">Symptom relief strategies</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1" className="border-0">
          <Accordion.Header className="bg-light hover-bg-primary">
            <div className="d-flex align-items-center">
              <FaAppleAlt className="text-primary fs-4 me-3" />
              <h3 className="mb-0">Preventive Care</h3>
            </div>
          </Accordion.Header>
          <Accordion.Body className="py-4">
            <Row className="g-4">
              <Col md={6}>
                <div className="p-4 bg-light rounded-3">
                  <h4 className="mb-3 text-primary">
                    <FaHeartbeat className="me-2" />
                    Screenings
                  </h4>
                  <ul className="list-unstyled">
                    <li className="d-flex align-items-center mb-3">
                      <div className="bullet bg-primary me-3"></div>
                      Annual Pap smears
                    </li>
                    <li className="d-flex align-items-center mb-3">
                      <div className="bullet bg-primary me-3"></div>
                      Breast cancer mammograms
                    </li>
                    <li className="d-flex align-items-center">
                      <div className="bullet bg-primary me-3"></div>
                      Bone density tests
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md={6}>
                <div className="p-4 bg-light rounded-3">
                  <h4 className="mb-3 text-primary">
                    <FaSyringe className="me-2" />
                    Vaccinations
                  </h4>
                  <ul className="list-unstyled">
                    <li className="d-flex align-items-center mb-3">
                      <div className="bullet bg-primary me-3"></div>
                      Tetanus Toxoid (TT)
                    </li>
                    <li className="d-flex align-items-center mb-3">
                      <div className="bullet bg-primary me-3"></div>
                      HPV Vaccine
                    </li>
                    <li className="d-flex align-items-center">
                      <div className="bullet bg-primary me-3"></div>
                      Influenza
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <Card className="border-0 shadow-lg overflow-hidden">
        <Card.Header className="bg-gradient-primary text-white py-4">
          <h3 className="mb-0">Specialized Services</h3>
        </Card.Header>
        <Card.Body className="p-4">
          <Row className="g-4">
            <Col md={4}>
              <div className="text-center p-4 hover-scale">
                <div className="icon-wrapper bg-primary text-white rounded-circle mb-3">
                  <FaHeartbeat className="fs-2" />
                </div>
                <h5>Cardiac Health</h5>
                <p className="text-muted mb-0">Cardiovascular risk assessment</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="text-center p-4 hover-scale">
                <div className="icon-wrapper bg-primary text-white rounded-circle mb-3">
                  <FaBrain className="fs-2" />
                </div>
                <h5>Mental Wellness</h5>
                <p className="text-muted mb-0">Anxiety & depression screening</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="text-center p-4 hover-scale">
                <div className="icon-wrapper bg-primary text-white rounded-circle mb-3">
                  <FaAppleAlt className="fs-2" />
                </div>
                <h5>Nutritional Support</h5>
                <p className="text-muted mb-0">Personalized diet plans</p>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default WomensHealth;